module.exports = __webpack_public_path__ + "img/DC-appointments-house.098dcf1e.svg";